export enum GiftCardStatus {
  USED = 'USED',
  NOT_USED = 'NOT_USED'
}

export interface GiftCardUser {
  email: string;
  firstName: string;
  lastName: string;
}

export interface GiftCard {
  amount: number;
  amountIRT: number;
  code: string;
  createdAt: string;
  description: string;
  status: GiftCardStatus;
}

export interface GiftCardCurrency {
  id: string;
  name: string;
}

export interface GiftCardContainer {
  createdByUser: GiftCardUser;
  redeemedByUser: GiftCardUser;
  giftcard: GiftCard;
  currency: GiftCardCurrency;
}
